import type { GridRenderCellParams } from "@mui/x-data-grid";
import { IconLinkButton } from "@components";
import { canEditUser } from "features/users/utils";
import { useAuth } from "features/auth";

export const TableUserActionsCell = (props: GridRenderCellParams<any, any>) => {
  const { user: currentUser } = useAuth();

  const hasAccess = canEditUser(currentUser, props?.row.role, props?.row.id);

  const link = `/users/${props?.row.email}/edit`;

  if (hasAccess) {
    return <IconLinkButton to={link} />;
  }

  return null;
};
